export abstract class TimeHelper {
	static convertSecondsToTimeboardStyle(seconds, isDropFloatPart) {
		let sec_num = parseInt(seconds, 10);
		let hours = Math.floor(sec_num / 3600);
		let minutes = Math.floor(sec_num / 60) % 60;
		let secs = sec_num % 60;
		let floatPartOfSeconds = (seconds - sec_num).toString().split('.')[1];
		floatPartOfSeconds = floatPartOfSeconds ? floatPartOfSeconds.substr(0, 2) : "00";//(seconds - sec_num).toFixed(2).split('.')[1];

		return [hours, minutes, secs]
			.map(v => v < 10 ? "0" + v : v)
			.filter((v, i) => v !== "00" || i > 0)
			.join(":") + (floatPartOfSeconds !== "00" && !isDropFloatPart ? "." + floatPartOfSeconds : "");
	}
}
